import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/back.svg';
const Back = () => React.createElement(IconSvg, null);
export default Back;
